@if (visible() && notificacion()) {
  <div class="toast toast--{{ notificacion()!.tipo }}" role="alert" aria-live="assertive">

    <div class="toast__head">
      <span class="toast__icon pi {{ iconoPorTipo(notificacion()!.tipo) }}"></span>
      <span class="toast__titulo">{{ notificacion()!.titulo }}</span>
      <button class="toast__close" type="button" (click)="cerrar()" aria-label="Cerrar notificación">
        <span class="pi pi-times"></span>
      </button>
    </div>

    <p class="toast__mensaje">{{ notificacion()!.mensaje }}</p>

    @if (notificacion()!.accion) {
      <div class="toast__footer">
        <button class="toast__accion" type="button" (click)="irAccion()">
          {{ notificacion()!.accion!.label }}
          <span class="pi pi-arrow-right"></span>
        </button>
      </div>
    }

    <div class="toast__progress-bar">
      <div class="toast__progress-fill" [style.width.%]="progreso()"></div>
    </div>

  </div>
}
